<section class="jumbotron2 text-center my-2">
  <h2 class="jumbotron-heading">VIDEOJUEGO - AMANTES DE SUMPA</h2>
</section>    

<section class="jumbotron text-center my-1 section1 px-5">
  <span class="d-grid gap-2 d-md-flex justify-content-md-end">
    <button mat-raised-button class="btn btn-dark margin2" (click)="openBuild()">
      <H5>INGRESAR AL JUEGO</H5>
    </button>&nbsp;&nbsp;
  </span>
  <div class="accordion p-2" id="accordion1">
    <div class="accordion-item">
      <h2 class="accordion-header" id="headingOne">
        <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
          Introducción
        </button>
      </h2>
      <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordion1">
        <div class="accordion-body2 p-2">
          <div class="jumbotron-heading" class="style6_1" style="text-align: justify">
            <svg width="2%" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 206.883 206.883" xml:space="preserve" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <g> <g> <path style="fill:#010002;" d="M198.812,81.941h-90.613c-4.173-0.021-11.56-6.65-12.687-10.568l-0.097-0.304 c-2.505-5.998,0.734-10.683,4.499-16.101c0.526-0.755,1.041-1.51,1.467-2.147c13.585-18.356,16.713-31.004-3.897-49.241 L93.773,7.77c16.323,14.437,16.957,23.012,3.021,41.83c-0.48,0.723-0.973,1.449-1.478,2.172 c-3.887,5.594-8.697,12.544-5.125,21.305c0.866,2.824,3.328,6.12,6.406,8.861H8.056C3.611,81.938,0,85.549,0,89.99v105.25 c0,4.441,3.611,8.063,8.056,8.063h190.76c4.456,0,8.067-3.622,8.067-8.063V89.997C206.879,85.552,203.272,81.941,198.812,81.941z M201.278,195.244c0,1.356-1.095,2.462-2.462,2.462H8.056c-1.356,0-2.462-1.109-2.462-2.462V89.997 c0-1.356,1.106-2.462,2.462-2.462h100.133l0.021,0.004l0.011-0.004h90.591c1.371,0,2.462,1.106,2.462,2.462v105.247H201.278z"></path> </g> <g> <rect x="28.226" y="104.334" style="fill:#010002;" width="17.722" height="17.719"></rect> </g> <g> <rect x="54.341" y="104.334" style="fill:#010002;" width="17.719" height="17.719"></rect> </g> <g> <rect x="81.583" y="104.334" style="fill:#010002;" width="17.726" height="17.719"></rect> </g> <g> <rect x="108.056" y="104.334" style="fill:#010002;" width="17.722" height="17.719"></rect> </g> <g> <rect x="134.185" y="104.334" style="fill:#010002;" width="17.719" height="17.719"></rect> </g> <g> <rect x="160.583" y="104.334" style="fill:#010002;" width="17.733" height="17.719"></rect> </g> <g> <rect x="54.638" y="164.896" style="fill:#010002;" width="71.273" height="17.726"></rect> </g> <g> <polygon style="fill:#010002;" points="71.899,151.482 71.899,133.756 55.744,133.756 54.166,133.756 28.051,133.756 28.051,151.482 54.166,151.482 55.744,151.482 "></polygon> </g> <g> <rect x="28.226" y="164.896" style="fill:#010002;" width="17.722" height="17.726"></rect> </g> <g> <rect x="81.408" y="133.756" style="fill:#010002;" width="17.726" height="17.726"></rect> </g> <g> <rect x="107.881" y="133.756" style="fill:#010002;" width="17.722" height="17.726"></rect> </g> <g> <rect x="133.999" y="133.756" style="fill:#010002;" width="17.73" height="17.726"></rect> </g> <g> <rect x="160.408" y="133.756" style="fill:#010002;" width="17.719" height="17.726"></rect> </g> <g> <rect x="134.185" y="164.896" style="fill:#010002;" width="17.719" height="17.726"></rect> </g> <g> <rect x="160.583" y="164.896" style="fill:#010002;" width="17.733" height="17.726"></rect> </g> </g> </g> </g></svg>
            &nbsp;&nbsp;El videojuego "MAS" surge como resultado de la colaboración entre la Universidad Técnica Particular de Loja y el Museo Amantes de Sumpa, situado en Santa Elena. Enmarcado dentro de un proyecto de Vinculación, el videojuego MAS es una emocionante herramienta educativa diseñada para abordar la carencia de recursos lúdicos que promuevan la identidad cultural. Su objetivo es fortalecer los materiales y recursos proporcionados por el Museo Amantes de Sumpa, con el fin de difundir y revalorizar las culturas de la costa ecuatoriana.
            <br/>
            <svg width="2%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M5 9C5 5.13401 8.13401 2 12 2C15.866 2 19 5.13401 19 9V15C19 18.866 15.866 22 12 22C8.13401 22 5 18.866 5 15V9ZM12 4C9.23858 4 7 6.23858 7 9V15C7 17.7614 9.23858 20 12 20C14.7614 20 17 17.7614 17 15V9C17 6.23858 14.7614 4 12 4ZM12 7C12.5523 7 13 7.44772 13 8V11C13 11.5523 12.5523 12 12 12C11.4477 12 11 11.5523 11 11V8C11 7.44772 11.4477 7 12 7Z" fill="#0F1729"></path> </g></svg>
            Este videojuego beneficia a más de 6.000 niños y niñas de quinto año de Educación Básica, pertenecientes a instituciones educativas y fiscales de dos distritos de la Libertad: Salinas y Santa Elena. En este viaje educativo, los jugadores se sumergen en el periodo precerámico (8000 - 4500 a.C.), acompañando a los personajes principales, Rei y Felipe, en emocionantes aventuras para proteger la cultura Las Vegas del malvado Pedro y así ser reconocidos como guardianes de la cultura.
          </div>  
        </div>  
      </div>
    </div>
    <div class="accordion-item">
      <h2 class="accordion-header" id="headingTwo">
        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
          ¡Objetivos del juego!
        </button>
      </h2>
      <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordion1">
        <div class="accordion-body2 p-2">
          <div class="jumbotron-heading" class="style6_1" style="text-align: justify">
            <div  class="py-2 team4">
              <div  class="container">
                <div class="row justify-content-center">
                  <div class="col-lg-2 mb-4">
                    <div class="card">
                      <div class="row text-center">
                        <div class="card-body rcorners1" style="margin:0px 5px;text-align: center;background:#cdd9e4">
                           <H3 class="style8">UNO</H3>Recuperar el artefacto de la máquina del tiempo.<br/><br/>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-2 mb-4">
                    <div class="card">
                      <div class="row text-center">
                        <div class="card-body rcorners2" style="margin:0px 5px;text-align: center; background:#c8edf0">
                          <H3 class="style12">DOS</H3>Replantar las zonas destruidas.<br/><br/>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-2 mb-4">
                    <div class="card">
                      <div class="row text-center">
                        <div class="card-body rcorners2" style="margin:0px 5px;text-align: center;background:#cdd9e4">
                          <H3 class="style13">TRES</H3>Recuperar los huesos y armar el rompecabezas.<br/><br/>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-2 mb-4">
                    <div class="card">
                      <div class="row text-center">
                        <div class="card-body rcorners2" style="margin:0px 5px;text-align: center;background:#c8edf0">
                          <H3 class="style12">CUATRO</H3>Recuperar los cráneos.<br/><br/><br/>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-2 mb-4">
                    <div class="card">
                      <div class="row text-center">
                        <div class="card-body rcorners3" style="margin:0px 5px;text-align: center;background:#cdd9e4">
                          <H3 class="style8">CINCO</H3>Búsqueda de piedras.<br/><br/><br/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>


<section class="jumbotron text-center my-4 section111 py-0 px-5" style="background: rgb(212, 212, 212);">
  
  <div class="row background1" >
    <div class="padding1"> 
      <section class="jumbotron2 text-center ">

        <div class="row row-cols-1 row-cols-md-3 g-4">
          <div class="col">
            <div class="card h-100 text-bg-secondary mb-3" >
              <img src="./assets/img/j1.png" class="card-img-top" alt="...">
              <div class="card-body">
                <h5 class="card-title">Acceso</h5>
                <p class="card-text">El usuario ingresa al entorno registrándose o podrá ingresar con su correo de Gmail.</p>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="card h-100">
              <img src="./assets/img/j2.png" class="card-img-top" alt="...">
              <div class="card-body">
                <h5 class="card-title">Reto 1: Artefacto de la máquina del tiempo</h5>
                <p class="card-text">Rei debe vencer a Pedro y recuperar la pieza de la máquina del tiempo.</p>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="card h-100">
              <img src="./assets/img/j3.png" class="card-img-top" alt="...">
              <div class="card-body">
                <h5 class="card-title">Reto 2:  Zonas destruidas</h5>
                <p class="card-text">Rei debe vencer a los amigos de Pedro, luego remplazará las plantaciones dañadas y sembrará nuevas.</p>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="card h-100">
              <img src="./assets/img/j4.png" class="card-img-top" alt="...">
              <div class="card-body">
                <h5 class="card-title">Reto 3: Huesos entierro amantes de Sumpa</h5>
                <p class="card-text">Rei deberá recolectar los huesos del entierro amantes de Sumpa y armar el rompecabezas.</p>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="card h-100">
              <img src="./assets/img/j5.png" class="card-img-top" alt="...">
              <div class="card-body">
                <h5 class="card-title">Reto 4:  Cráneos entierros</h5>
                <p class="card-text">Rei Dentro de esta actividad el personaje principal debe encontrar los cráneos robados.</p>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="card h-100">
              <img src="./assets/img/j6.png" class="card-img-top" alt="...">
              <div class="card-body">
                <h5 class="card-title">Reto 5: Búsqueda de piedras</h5>
                <p class="card-text">Rei debe localizar cada una de las piedras desplegadas por el escenario.</p>
              </div>
            </div>
          </div>
        </div>

      </section> 
    </div>
  </div>   
</section>

<section class="jumbotron2 text-center my-4">
  <div class="container  mt-4" class="style2">
        <div class="row">
          <div class="col-12 text-center" style="background:#fff">
            <div class="section-title">
              <h2 class="jumbotron-heading">¡Experimenta con nuestro DIVERTIDO JUEGO !</h2>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 text-center" style="background:#fff">
            <div class="section-title mb-4 pb-12">
              <a mat-raised-button class="btn btn-success margin1" target="_blank" href="https://view.genial.ly/6568ef6a1adb870014ca77a2">
                <H4>Manual interactivo</H4>
              </a>&nbsp;&nbsp;
              <button mat-raised-button class="btn btn-dark margin2" (click)="openBuild()">
                <H4>INGRESAR AL JUEGO</H4>
              </button>
            </div>
          </div>
        </div>
  </div>
</section>  

<section class="jumbotron text-center my-2 style3">
  
  <div  class="py-2 team4">
    <div  class="container2">
      <div class="row justify-content-center">
        <div class="col-lg-3 mb-4">
          <section class="style8 text-center my-1">
            <h5>EQUIPO UTPL</h5>
          </section>   
          <div class="card">
            <div class="row text-center">
              <div class="col-md-12">
                <div id="carouselExampleCaptions1" class="carousel slide carousel-fade" data-ride="carousel">
                  <ol class="carousel-indicators">
                    <li data-target="#carouselExampleCaptions1" data-slide-to="0" class="active"></li>
                    <li data-target="#carouselExampleCaptions1" data-slide-to="1"></li>
                    <li data-target="#carouselExampleCaptions1" data-slide-to="2"></li>
                  </ol>
                  <div class="carousel-inner">
                    <div class="carousel-item active">
                      <img class="d-block w-100" src="./assets/img/utpl/Claudia_Cartuche.png" alt="First slide">
                      <div class="carousel-caption d-none d-md-block style9">
                        <h5>CLAUDIA CARTUCHE</h5>
                        <p>DIRECTORA DEL PROYECTO</p>
                      </div>
                    </div>
                    <div class="carousel-item">
                      <img class="d-block w-100" src="./assets/img/utpl/Jennifer_Samaniego.png" alt="First slide">
                      <div class="carousel-caption d-none d-md-block style9">
                        <h5>JENNIFER SAMANIEGO</h5>
                        <p>CODIRECCIÓN DEL PROYECTO</p>
                      </div>
                    </div>
                    <div class="carousel-item">
                      <img class="d-block w-100" src="./assets/img/utpl/Luis_Rios.png" alt="First slide">
                      <div class="carousel-caption d-none d-md-block style9">
                        <h5>LUIS RÍOS</h5>
                        <p>INTEGRANTE DEL PROYECTO</p>
                      </div>
                    </div>
                    <div class="carousel-item">
                      <img class="d-block w-100" src="./assets/img/utpl/Marlon_Carrion.png" alt="First slide">
                      <div class="carousel-caption d-none d-md-block style9">
                        <h5>MARLON CARRIÓN</h5>
                        <p>INTEGRANTE DEL PROYECTO</p>
                      </div>
                    </div>
                    <div class="carousel-item">
                      <img class="d-block w-100" src="./assets/img/utpl/Stalin_Carrion.png" alt="First slide">
                      <div class="carousel-caption d-none d-md-block style9">
                        <h5>STALIN CARRIÓN</h5>
                        <p>DESARROLLO UNITY</p>
                      </div>
                    </div>
                    <div class="carousel-item">
                      <img class="d-block w-100" src="./assets/img/utpl/Alex_Romero.png" alt="First slide">
                      <div class="carousel-caption d-none d-md-block style9">
                        <h5>ALEX ROMERO</h5>
                        <p>DESARROLLO ANGULAR</p>
                      </div>
                    </div>
                  </div>
                  <a class="carousel-control-prev" href="#carouselExampleCaptions1" role="button" data-slide="prev">
                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span class="sr-only">Previous</span>
                  </a>
                  <a class="carousel-control-next" href="#carouselExampleCaptions1" role="button" data-slide="next">
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                    <span class="sr-only">Next</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 mb-4">
          <section class="style9 text-center my-1">
            <h5>EQUIPO TÉCNICO</h5>
          </section>  
          <div class="card">
            <div class="row text-center">
              <div class="col-md-12">
                <div id="carouselExampleCaptions2" class="carousel slide carousel-fade" data-ride="carousel">
                  <ol class="carousel-indicators">
                    <li data-target="#carouselExampleCaptions1" data-slide-to="0" class="active"></li>
                    <li data-target="#carouselExampleCaptions1" data-slide-to="1"></li>
                    <li data-target="#carouselExampleCaptions1" data-slide-to="2"></li>
                  </ol>
                  <div class="carousel-inner">
                    <div class="carousel-item active">
                      <img class="d-block w-100" src="./assets/img/tecnico/Jorge_Sarmiento.png" alt="First slide">
                      <div class="carousel-caption d-none2 d-md-block style9">
                        <h5>JORGE SARMIENTO</h5>
                        <p>DESARROLLO UNITY</p>
                      </div>
                    </div>
                    <div class="carousel-item">
                      <img class="d-block w-100" src="./assets/img/tecnico/Jaime_Erice.png" alt="First slide">
                      <div class="carousel-caption d-none2 d-md-block style9">
                        <h5>JAIME SEBASTIÁN DE ERICE</h5>
                        <p>DESARROLLO UNITY</p>
                      </div>
                    </div>
                    <div class="carousel-item">
                      <img class="d-block w-100" src="./assets/img/tecnico/Jose_Romero.png" alt="First slide">
                      <div class="carousel-caption d-none2 d-md-block style9">
                        <h5>JOSÉ ROMERO SALCEDO</h5>
                        <p>MODELADO 3D</p>
                      </div>
                    </div>
                    <div class="carousel-item">
                      <img class="d-block w-100" src="./assets/img/tecnico/Wimper_Tigrero.png" alt="First slide">
                      <div class="carousel-caption d-none2 d-md-block style9">
                        <h5>WIMPER TIGREO</h5>
                        <p>MODELADO 3D</p>
                      </div>
                    </div>
                  </div>
                  <a class="carousel-control-prev" href="#carouselExampleCaptions2" role="button" data-slide="prev">
                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span class="sr-only">Previous</span>
                  </a>
                  <a class="carousel-control-next" href="#carouselExampleCaptions2" role="button" data-slide="next">
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                    <span class="sr-only">Next</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 mb-4">
          <section class="style11 text-center my-1">
            <h5>ESTUDIANTES DE ARTE</h5>
          </section>  
          <div class="card">
            <div class="row text-center">
              <div class="col-md-12">
                <div id="carouselExampleCaptions3" class="carousel slide carousel-fade" data-ride="carousel">
                  <ol class="carousel-indicators">
                    <li data-target="#carouselExampleCaptions1" data-slide-to="0" class="active"></li>
                    <li data-target="#carouselExampleCaptions1" data-slide-to="1"></li>
                    <li data-target="#carouselExampleCaptions1" data-slide-to="2"></li>
                  </ol>
                  <div class="carousel-inner">
                    <div class="carousel-item active">
                      <img class="d-block w-100" src="./assets/img/arte/Juan_Burneo.png" alt="First slide">
                      <div class="carousel-caption d-none d-md-block style9">
                        <h5>JUAN DIEGO BURNEO</h5>
                        <p>ESTUDIANTE UTPL</p>
                      </div>
                    </div>
                    <div class="carousel-item">
                      <img class="d-block w-100" src="./assets/img/arte/Raphaella_Borrero.png" alt="First slide">
                      <div class="carousel-caption d-none2 d-md-block style9">
                        <h5>RAPHAELLA MARIE BORRERO NAULA</h5>
                        <p>ESTUDIANTE UTPL</p>
                      </div>
                    </div>
                    <div class="carousel-item">
                      <img class="d-block w-100" src="./assets/img/arte/Byron Maldonado.png" alt="First slide">
                      <div class="carousel-caption d-none2 d-md-block style9">
                        <h5>BYRON ANDRÉS CABRERA ALDAZ</h5>
                        <p>ESTUDIANTE UTPL</p>
                      </div>
                    </div>
                    <div class="carousel-item">
                      <img class="d-block w-100" src="./assets/img/arte/Zoila_Jumbo.png" alt="First slide">
                      <div class="carousel-caption d-none2 d-md-block style9">
                        <h5>ZOILA GABRIELA JUMBO VACACELA</h5>
                        <p>ESTUDIANTE UTPL</p>
                      </div>
                    </div>
                    <div class="carousel-item">
                      <img class="d-block w-100" src="./assets/img/arte/Ana_Noboa.png" alt="First slide">
                      <div class="carousel-caption d-none2 d-md-block style9">
                        <h5>ANA PAULA NOBOA JARAMILLO</h5>
                        <p>ESTUDIANTE UTPL</p>
                      </div>
                    </div>
                    <div class="carousel-item">
                      <img class="d-block w-100" src="./assets/img/arte/Cristina_Prado.png" alt="First slide">
                      <div class="carousel-caption d-none2 d-md-block style9">
                        <h5>CRISTINA ALEJANDRA PRADO CORDERO</h5>
                        <p>ESTUDIANTE UTPL</p>
                      </div>
                    </div>
                    <div class="carousel-item">
                      <img class="d-block w-100" src="./assets/img/arte/Estela_Reis.png" alt="First slide">
                      <div class="carousel-caption d-none2 d-md-block style9">
                        <h5>ESTELA REIS BIANCHINI</h5>
                        <p>ESTUDIANTE UTPL</p>
                      </div>
                    </div>
                    <div class="carousel-item">
                      <img class="d-block w-100" src="./assets/img/arte/Nayeli_Sanchez.png" alt="First slide">
                      <div class="carousel-caption d-none2 d-md-block style9">
                        <h5>NAYELY LIZBETH SÁNCHEZ SANTÍN</h5>
                        <p>ESTUDIANTE UTPL</p>
                      </div>
                    </div>
                    <div class="carousel-item">
                      <img class="d-block w-100" src="./assets/img/arte/Adriana_Yanza.png" alt="First slide">
                      <div class="carousel-caption d-none2 d-md-block style9">
                        <h5>ADRIANA ANAVELA YANZA YANZA</h5>
                        <p>ESTUDIANTE UTPL</p>
                      </div>
                    </div>
                    
                  </div>
                  <a class="carousel-control-prev" href="#carouselExampleCaptions3" role="button" data-slide="prev">
                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span class="sr-only">Previous</span>
                  </a>
                  <a class="carousel-control-next" href="#carouselExampleCaptions3" role="button" data-slide="next">
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                    <span class="sr-only">Next</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="jumbotron text-center my-4 py-0 px-5 style7" style="background: #ffffff;">
  <div class="row background11111" >
    <div class="padding3"> 
      <section class="jumbotron2 text-center">
        <div class="row row-cols-1 row-cols-md-4 g-4">
          <div class="col">
            <div class="card h-100" style="border:0px;width:80%;margin:0 auto" >
              <img src="./assets/img/logos/utpl.png" class="card-img-center" alt="...">
            </div>
          </div>
          <div class="col">
            <div class="card h-100" style="border:0px;width:40%;margin:0 auto">
              <img src="./assets/img/logos/xrlab.png" class="card-img-center" alt="...">
            </div>
          </div>
          <div class="col">
            <div class="card h-100" style="border:0px;width:80%;margin:0 auto">
              <img src="./assets/img/logos/amantes.png" class="card-img-top" alt="...">
            </div>
          </div>
          <div class="col">
            <div class="card h-100" style="border:0px;width:80%;margin:0 auto">
              <img src="./assets/img/logos/antropologico.png" class="card-img-top" alt="...">
            </div>
          </div>
        </div>
      </section> 
    </div>
  </div>   
</section>

<footer>
  <div class="text-center p-3">
    © 2024 Copyright:
    <a class="text-dark" href="https://utpl.edu.ec/">UTPL</a>
  </div>
</footer>
